import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Button } from "./Button.js";
import { Tooltip } from "./Tooltip.js";
import { mergeRefs } from "./mergeRefs.js";
import { useToolbarContext } from "./context9.js";
const ToolbarButton = forwardRef((props, ref) => {
  const {
    isSmall
  } = useToolbarContext();
  if (!props.children && "aria-label" in props) {
    return /* @__PURE__ */ jsx(Tooltip, {
      content: props["aria-label"],
      timing: "delay",
      children: (triggerProps) => /* @__PURE__ */ jsx(Button, {
        ...props,
        variant: "clean",
        isSmall,
        ...triggerProps,
        ref: mergeRefs(triggerProps.ref, ref)
      })
    });
  }
  return /* @__PURE__ */ jsx(Button, {
    ref,
    ...props,
    variant: "clean",
    isSmall
  });
});
export {
  ToolbarButton
};
//# sourceMappingURL=ToolbarButton.js.map
